import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "relative border border-gray-200 shadow-sm rounded-md bg-gray-50" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 1,
  class: "-mt-10 w-20 mx-auto block"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 3,
  class: "font-medium text-xl block mt-4 text-gray-700 mx-auto w-fit"
}
const _hoisted_6 = { class: "text-lg text-center block text-indigo-600 font-medium" }
const _hoisted_7 = { class: "bg-white p-6 pt-4 mt-6 overflow-hidden rounded-b-md" }
const _hoisted_8 = { class: "flex space-x-5 mt-4 mb-0" }
const _hoisted_9 = ["href", "title"]
const _hoisted_10 = { class: "sr-only" }
const _hoisted_11 = {
  key: 0,
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", { d: "M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("path", { d: "M12 14l9-5-9-5-9 5 9 5z" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("path", { d: "M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
}, null, -1)
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 4,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
}, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 5,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]

import { PropType } from 'vue';
import { Author } from '@/common/authors';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorBox',
  props: {
  author: {
    type: Object as PropType<Author>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.author.url)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: __props.author.url,
          class: "-mt-10 w-20 mx-auto block"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: __props.author.img,
              class: "rounded-full",
              alt: `${__props.author.firstName} ${__props.author.lastName}`
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createElementVNode("img", {
            src: __props.author.img,
            class: "rounded-full",
            alt: `${__props.author.firstName} ${__props.author.lastName}`
          }, null, 8, _hoisted_4)
        ])),
    (__props.author.url)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 2,
          to: __props.author.url,
          class: "font-medium text-xl block mt-4 text-gray-700 mx-auto w-fit"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.author.firstName) + " " + _toDisplayString(__props.author.lastName), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.author.firstName) + " " + _toDisplayString(__props.author.lastName), 1)),
    _createElementVNode("span", _hoisted_6, _toDisplayString(__props.author.title), 1),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.author.bio, (bioParagraph) => {
        return (_openBlock(), _createElementBlock("span", {
          key: bioParagraph,
          class: "block pt-2 text-gray-700"
        }, _toDisplayString(bioParagraph), 1))
      }), 128)),
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.author.socials, (social) => {
          return (_openBlock(), _createElementBlock("li", {
            key: social.url
          }, [
            _createElementVNode("a", {
              href: social.url,
              class: "text-gray-400 hover:text-gray-500",
              title: `${__props.author.firstName}'s ${social.platform} profile`
            }, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(social.platform), 1),
              (social.platform === 'Twitter')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))
                : (social.platform === 'LinkedIn')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16))
                  : (social.platform === 'Google Scholar')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_21))
                    : (social.platform === 'IETF')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_24))
                      : (social.platform === 'Google Patents')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_25, _hoisted_27))
                        : (social.platform === 'Website')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_30))
                          : _createCommentVNode("", true)
            ], 8, _hoisted_9)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})